export class LoginModel {
    constructor(public email: string, public password: string, public rememberMe: boolean) {
    }
}



// WEBPACK FOOTER //
// /Volumes/Projects/dev2/ng2fb-bootstrap/src/app/+login/login.model.ts